'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isMobile = require('../../common/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ARROWS = {
  right: _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' }),
  left: _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' }),
  down: _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' }),
  up: _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
};

var Arrow = function Arrow(_ref) {
  var name = _ref.name,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? _isMobile2.default ? 25 : 20 : _ref$size;

  return _react2.default.createElement(
    'svg',
    {
      className: className + ' ' + className + '--' + name,
      height: size.height || size,
      width: size.width || size,
      viewBox: '0 0 24 24'
    },
    ARROWS[name]
  );
};

exports.default = Arrow;